var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import UsageReport from "./component/UsageReport/UsageReport";
import TransactionHistory from "./component/TransactionHistory/TransactionHistory";
import { JssProvider } from "react-jss";
import { createGenerateClassName } from "@material-ui/core/styles";
var generateClassName = createGenerateClassName({
    dangerouslyUseGlobalCSS: true,
});
function Router() {
    return (_jsx(JssProvider, __assign({ generateClassName: generateClassName, disableStylesGeneration: true }, { children: _jsx(BrowserRouter, { children: _jsxs(Switch, { children: [_jsx(Route, { exact: true, path: "/", component: UsageReport }), _jsx(Route, { path: "/UsageReport", component: UsageReport }), _jsx(Route, { path: "/ExtensionTransactionHistory", component: TransactionHistory })] }) }) })));
}
export default Router;
